import React from 'react';
import { Badge } from './ui/badge';
import { FileText, Shield, CheckCircle, AlertTriangle, Clock, FileCheck } from 'lucide-react';

export const getDocumentIcon = (type) => {
  switch (type) {
    case 'attestation_ftpe':
      return <Shield className="h-5 w-5 text-blue-600" />;
    case 'attestation_rcds':
      return <FileCheck className="h-5 w-5 text-green-600" />;
    case 'devis_ess':
    case 'devis_ess_genere':
      return <FileText className="h-5 w-5 text-purple-600" />;
    case 'conditions_generales':
      return <FileText className="h-5 w-5 text-gray-600" />;
    case 'avenant':
      return <FileText className="h-5 w-5 text-orange-600" />;
    default:
      return <FileText className="h-5 w-5 text-gray-500" />;
  }
};

export const getStatusBadge = (doc) => {
  if (doc.en_validation) {
    return (
      <Badge data-testid={`badge-en-validation-${doc.id}`} className="bg-amber-500 text-white border border-amber-700 font-semibold">
        <Clock className="h-3 w-3 mr-1" />
        En cours de validation
      </Badge>
    );
  }
  if (doc.statut_validation?.valide && doc.is_valid) {
    return (
      <Badge data-testid={`badge-verifie-${doc.id}`} className="bg-emerald-700 text-white border border-emerald-900 font-semibold">
        <CheckCircle className="h-3 w-3 mr-1" />
        Vérifié — validé{doc.statut_validation.date_validation ? ` le ${doc.statut_validation.date_validation}` : ''}
      </Badge>
    );
  }
  // FTPE: afficher le document_status specifique
  if (doc.type === 'attestation_ftpe' && doc.document_status) {
    switch (doc.document_status) {
      case 'signee':
        return (
          <Badge data-testid={`badge-signee-${doc.id}`} className="bg-emerald-700 text-white border border-emerald-900 font-semibold">
            <CheckCircle className="h-3 w-3 mr-1" />
            Signee
          </Badge>
        );
      case 'non_signee':
        return (
          <Badge data-testid={`badge-non-signee-${doc.id}`} className="bg-amber-600 text-white border border-amber-800 font-semibold">
            <AlertTriangle className="h-3 w-3 mr-1" />
            Non signee
          </Badge>
        );
      case 'en_cours':
        return (
          <Badge data-testid={`badge-en-cours-${doc.id}`} className="bg-blue-700 text-white border border-blue-900 font-semibold">
            <Clock className="h-3 w-3 mr-1" />
            En cours
          </Badge>
        );
      default:
        break;
    }
  }

  if (!doc.is_valid) {
    return (
      <Badge className="bg-red-700 text-white border border-red-900 font-semibold">
        <AlertTriangle className="h-3 w-3 mr-1" />
        Expire
      </Badge>
    );
  }
  if (doc.status === 'active') {
    return (
      <Badge className="bg-green-700 text-white border border-green-900 font-semibold">
        <CheckCircle className="h-3 w-3 mr-1" />
        Valide
      </Badge>
    );
  }
  return (
    <Badge variant="outline">
      <Clock className="h-3 w-3 mr-1" />
      {doc.status}
    </Badge>
  );
};

export const getTypeLabel = (type) => {
  const labels = {
    'attestation_ftpe': 'Attestation FTPE',
    'attestation_rcds': 'Attestation RCDS',
    'devis_ess': 'Devis ESS',
    'devis_ess_genere': 'Devis ESS',
    'conditions_generales': 'Conditions Générales',
    'avenant': 'Avenant',
    'document': 'Document'
  };
  return labels[type] || 'Document';
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
};
